import axios from "axios";
import { PARTNER_TOKEN_KEY, parErr } from "@/lib/partnerApi";

const ROOT = process.env.REACT_APP_BACKEND_URL;
const BASE = `${ROOT}/api/doc`;

const client = (tokenKey, params = {}) => {
  const headers = () => {
    const t = tokenKey && localStorage.getItem(tokenKey);
    return t ? { Authorization: `Bearer ${t}` } : {};
  };
  const cfg = (extra) => ({ headers: headers(), params: { ...params, ...extra } });
  return {
    get: (path, p) => axios.get(`${BASE}${path}`, cfg(p)).then((r) => r.data),
    post: (path, body) => axios.post(`${BASE}${path}`, body, cfg()).then((r) => r.data),
    put: (path, body) => axios.put(`${BASE}${path}`, body, cfg()).then((r) => r.data),
    openPdf: (path, p) => axios.get(`${BASE}${path}`, { ...cfg(p), responseType: "blob" })
      .then((r) => window.open(URL.createObjectURL(r.data), "_blank", "noopener")),
  };
};

/** Staff client (nex_token). */
export const docApi = client("nex_token");
/** Partner portal client — partner token only. */
export const partnerDocApi = client(PARTNER_TOKEN_KEY);
/** Resident portal / public link clients: no bearer, token travels as a query param or path. */
export const residentDocApi = (token) => client(null, { token });
export const publicDocApi = client(null);

export const docErr = parErr;
const KEY = (k) => `tea_doc_${k}`;
export const docPref = {
  get: (k, fallback) => localStorage.getItem(KEY(k)) || fallback,
  set: (k, v) => localStorage.setItem(KEY(k), v),
};

export const isPmc = (u) => u?.role === "super_admin" || (u?.staff_permissions || []).includes("pmc");
export const isSa = (u) => u?.role === "super_admin";

export const DOC_CHIP = { draft: ["grey", "Draft"], review: ["yellow", "Review"], finalized: ["blue", "Finalized"], assigned: ["purple", "Assigned"], signed: ["green", "Signed"], voided: ["darkgrey", "Voided"] };
export const ASG_CHIP = { pending: ["yellow", "Pending"], viewed: ["blue", "Viewed"], signed: ["green", "Signed"], acknowledged: ["green", "Acknowledged"], expired: ["orange", "Expired"], voided: ["darkgrey", "Voided"] };
export const TPL_CHIP = { active: ["green", "Active"], archived: ["darkgrey", "Archived"] };
export const RECIPIENT_TYPES = [["resident", "Resident"], ["partner", "Partner"], ["staff", "Staff"], ["public", "Public"]];
export const ASSIGNMENT_TYPES = [["signature_required", "Signature required"], ["acknowledgment_only", "Acknowledgment only"], ["for_record", "For record"]];
